import React from 'react';

const CustomerLogo = () => {
    return <div className={'h-auto flex max-w-[100px] md:max-w-[200px]'}>
        <img src={`/themes/${window.location.hostname.split('.')[0]}/logo.png`} alt={'Logo'} />
    </div>;
};

export default CustomerLogo;
